import { create, tsx } from '@dojo/framework/core/vdom';
import * as css from './ContentWrapper.m.css';

export interface ContentWrapperProperties {
	size?: 'normal' | 'medium' | 'small' | 'smaller' | 'smallest';
	paddingTop?: 'medium' | 'large' | 'larger';
	paddingBottom?: 'medium' | 'large';
	responsive?: boolean;
}

const factory = create().properties<ContentWrapperProperties>();

export const ContentWrapper = factory(function ContentWrapper({ properties, children }) {
	const { size = 'normal', paddingTop, paddingBottom, responsive = false } = properties();

	const classes = [
		size === 'normal' && css.normal,
		size === 'medium' && css.medium,
		size === 'small' && css.small,
		size === 'smaller' && css.smaller,
		size === 'smallest' && css.smallest,
		paddingTop === 'medium' && css.mediumPaddingTop,
		paddingTop === 'large' && css.largePaddingTop,
		paddingTop === 'larger' && css.largerPaddingTop,
		paddingBottom === 'medium' && css.mediumPaddingBottom,
		paddingBottom === 'large' && css.largePaddingBottom,
		responsive && css.responsive
	];

	return <div classes={classes}>{children()}</div>;
});

export default ContentWrapper;
